import List from 'list.js'

if (jQuery('#hcplayer-search .list').length !== 0) {

    let playerSearch = new List('hcplayer-search', {
        valueNames: ['hcplayer__name__val'],
        fuzzySearch: {
            location: 0,
            threshold: 0.2,
        }
    }).on('searchComplete', function () {

        addUniqueLetters()

    }).on('searchStart', function () {

        let els = jQuery('.unique')
        els.remove()

    })

    addUniqueLetters()

}

let hplayer = jQuery('.hplayer')

hplayer.on('click', function () {

    if (jQuery(this).hasClass('open')) {
        jQuery('.hplayer').removeClass('open')
    } else {
        jQuery('.hplayer').removeClass('open')
        jQuery(this).addClass('open')
    }

})

function addUniqueLetters() {

    let els = jQuery('.player__block__holder'),
        letterIndex = ''

        

    els.each(function () {

        let el = jQuery(this),
            letter = el.data('letter')

        if (letterIndex === '') {

            letterIndex = letter
            jQuery()
            el.parent().before(`<h2 class="unique">${letter}</h2>`)

        } else if (letterIndex !== letter) {

            letterIndex = letter
            el.parent().before(`<h2 class="unique">${letter}</h2>`)

        }

    })

}
